module.exports = __webpack_public_path__ + "img/logoIconDark.990d30a8.png";